import { Address, GenericObject, copyFields } from '@synergy/models';
import { Dayjs } from 'dayjs';

import { ConverterPositionItem } from './converter-positionItem';

export class ConverterCustomerSupplier {
    public id!: number;
    public name!: string | Dayjs;
    public items!: ConverterPositionItem[];
    public deliveryPrice?: number;
    public surcharge?: number;
    public address?: Address;
    public deliveryDate?: Date;
    /** Whether the supplier is locked today — see ConverterCustomer. */
    public isLocked?: boolean;
    /** The best bid of its address, shown and not ticked (R-222). */
    public isBestOffer?: boolean;

    public static fromPlainObject(object: GenericObject): ConverterCustomerSupplier {
        const customerSupplier = new ConverterCustomerSupplier();

        copyFields(object, customerSupplier);

        if (object['items']) {
            customerSupplier.items = object['items'].map(ConverterPositionItem.fromPlainObject);
        }

        return customerSupplier;
    }
}
